import posthog from "posthog-js";

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST =
  process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

const isEnabled = Boolean(POSTHOG_KEY);

if (isEnabled) {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    defaults: "2026-05-30",
    person_profiles: "always",
    capture_pageview: false,
    capture_pageleave: true,
  });
} else if (process.env.NODE_ENV !== "production") {
  console.info("PostHog analytics disabled: REACT_APP_POSTHOG_KEY is not set.");
}

const analytics = {
  capture: (eventName, properties) => {
    if (isEnabled) {
      posthog.capture(eventName, properties);
    }
  },
  identify: (userId, properties) => {
    if (isEnabled) {
      posthog.identify(userId, properties);
    }
  },
  reset: () => {
    if (isEnabled) {
      posthog.reset();
    }
  },
};

export default analytics;
